import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
    document.getElementById("add_to_cart_btn").disabled = false;
    document.getElementById("addToCartSpinner").classList.add("hidden");
  }

}